module.exports = __webpack_public_path__ + "static/media/article9Photo.33b914e2.png";